import { Box, Container } from "@mui/material"
import docuDashboard from "../../../assets/imgs/Dashboards/inteligenceDashboard.png"
import docuCharleeRobot from "../../../assets/imgs/Dashboards/docuCharlee_robot.png"
import patterns from "../../../assets/imgs/pattens/Path.png"
export const DocuDashboard = () => {
  return (
    <Box className="w-full relative">
      <div
        className="h-[400px] w-full absolute top-[50%]"
        role="presentation"
        aria-hidden="true"
        style={{background: `url(${patterns})`, backgroundRepeat: 'repeat-x', transform: 'translateY(-50%)'}}
      />
      <Container maxWidth="lg">
        <Box
          className="docuChalee-board docuChalee-board w-full relative"
          role="img"
          aria-label="DocuCharlee document intelligence dashboard summarizing claim files"
          sx={{background: `url(${docuDashboard})`, backgroundRepeat: "no-repeat", backgroundSize: '110%', backgroundPosition: 'center'}}
        >
          <img src={docuDashboard} alt="DocuCharlee document intelligence dashboard interface" className="hidden md:block w-full mx-auto opacity-0" style={{maxWidth: '100vw'}} width={1200} height={700} loading="lazy" />
          <img src={docuCharleeRobot} alt="DocuCharlee AI assistant mascot" className="docuChalee-bot hidden md:block absolute bottom-0 left-0" style={{transform: 'translate(-15%, -20%)'}} width={280} height={379} loading="lazy" />
          <img src={docuDashboard} alt="DocuCharlee document intelligence dashboard on mobile" className="docuChalee-Mboard block md:hidden w-[130vw] mx-auto" style={{maxWidth: '200vw', transform: 'translate(-18vw, 0)'}} width={800} height={500} loading="lazy" />
          <img src={docuCharleeRobot} alt="DocuCharlee AI assistant mascot on mobile" className="docuChalee-Mbot block md:hidden absolute bottom-0 left-0"  style={{transform: 'translate(-26%, 17%)'}} width={200} height={270} loading="lazy" />
        </Box>
      </Container>
    </Box>
  )
}
